import React from "react";

const GetinTouch = () => {
  return (
    <div className="mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-32 lg:px-20 ">
      <div className="font-serif items-center text-center mt-8 mb-5">
        <h1 className="text-3xl font-bold  text-black">Get in Touch</h1>
        <p className="font-serif">
          Nullam quis risus eget urna mollis ornare vel eu leo. Fusce dapibus,
          tellus ac cursus commodo, tortor mauris <br /> condimentum nibh, ut
          fermentum massa justo sit amet risus. Integer posuere erat.
        </p>
      </div>
      <div>
        <form className=" bg-gray-100  rounded-lg px-12 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <input
              name="firstName"
              type="text"
              placeholder=" Name"
              className="input input-ghost w-full p-2 bg-white shadow-xl input-bordered"
            />
            <input
              name="phone"
              type="text"
              placeholder="Your Phone"
              className="input input-ghost w-full p-2 bg-white shadow-xl  input-bordered"
              required
            />

            <select
              id="countries"
              className="input input-ghost w-full p-2 bg-white shadow-xl  input-bordered"
            >
              <option selected>Select Your Department</option>
              <option value="US">Sales</option>
              <option value="CA">Marketing</option>
              <option value="FR">Customer Support</option>
              <option value="DE">Other</option>
            </select>

            <input
              name="email"
              type="text"
              placeholder="Your email"
              className="input input-ghost w-full p-2 bg-white shadow-xl input-bordered"
            />
          </div>
          <textarea
            name="message"
            className="textarea textarea-bordered mt-8  bg-white shadow-xl mb-8 h-32 w-full"
            placeholder="Your Message"
            required
          ></textarea>
          <div className="text-gray-700  mt-5 mb-5 text-center justify-center mx-auto">
            <div className="flex">
              <span className="me-4"> Subject:</span>
              <span className="me-3">
                <input
                  type="radio"
                  name="General"
                  id="General"
                  className="text-7xl"
                />{" "}
                General
              </span>
              <span className="me-3">
                <input
                  type="radio"
                  name="General"
                  id="General"
                  className="text-7xl "
                />{" "}
                Say Hi
              </span>
              <span>
                <input
                  type="radio"
                  name="General"
                  id="General"
                  className="text-7xl"
                />{" "}
                Other
              </span>
            </div>{" "}
            <button className=" bg-green-500   text-white font-bold rounded-lg shadow-2xl p-3">
              Submit Your Message
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GetinTouch;
